const postal = require('postal');

function RRPubSub() {
	this.channel = postal.channel('richer-relevance');
	this.EVENTS = {
		ADD_TO_CART: 'TAG.ADD_TO_CART',
		ADD_TO_WISHLIST: 'TAG.ADD_TO_WISHLIST',
		PAGING_SEARCH: 'TAG.SEARCH_PAGE',
        // PAGING_SEARCH_NO_RESULT: 'TAG.SEARCH_PAGE_NO_RESULT',
        CART_PAGE: 'TAG.CART_PAGE',
		CATEGORY_PAGE: 'TAG.CATEGORY_PAGE',
        DEPARTMENT_PAGE: 'TAG.DEPARTMENT_PAGE',
        WISHLIST_PAGE: 'TAG.WISHLIST_PAGE'
	};
}

RRPubSub.prototype.publish = function (topic, request) {
	this.channel.publish(topic, request);
};


module.exports = RRPubSub;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/richer-relevance/rr-pub-sub.js
 **/